import React, { useState, useEffect } from "react";
import { formValidator } from "utils/FormValidator/FormValidator";
import CustomInputBox from "utils/CustomInputBox/CustomInputBox";
import CustomSelect from "utils/Select/CustomSelect/CustomSelect";
import RangeSelect from "utils/RangeSelect/RangeSelect";
import { stockTransType } from "../../../../constants";
import { getBalance } from "utils/helpers";

const BuyStockPriceForm = ({
	order,
	toggle,
	nextStep,
	price_type,
	orderTerms,
}) => {
	const [formErrors, setFormErrors] = useState({});
	const [total, setTotal] = useState(0);
	const [resetRange, setResetRange] = useState(false);
	const [request, setRequest] = useState({
		price: order?.price || order?.stock?.price || 0,
		quantity: 1,
		term: "",
		stop_price: order?.price || order?.stock?.price || 0,
		price_limit: order?.price || order?.stock?.price || 0,
	});

	const isMarket = price_type === stockTransType.MARKET;

	const { cashBalance } = getBalance();

	useEffect(() => {
		setTotal(
			(isMarket ? request?.price : request?.price_limit) *
				request?.quantity
		);
	}, [isMarket, price_type, request]);

	const handleError = (name, value = "") => {
		setFormErrors((prev) => ({
			...prev,
			[name]: value,
		}));
	};

	const handleSelect = (name, value) => {
		setRequest((prev) => ({
			...prev,
			[name]: value,
		}));
		handleError(name);
	};

	const handleChange = ({ target: { name, value } }) => {
		name === "quantity"
			? validateQuantity(value)
			: handleSelect(name, value);
		setResetRange((prev) => !prev);
	};

	const validateQuantity = (value) => {
		if (Number(request.price) * Number(value) > cashBalance)
			handleError("quantity", "You have exceeded your available balance");
		else handleSelect("quantity", value);
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		const payload = { ...request };
		const { quantity, term, price_limit, stop_price } = request || {};
		delete payload.term;
		if (isMarket) {
			delete payload.stop_price;
			delete payload.price_limit;
		}
		price_type === stockTransType.LIMIT && delete payload.stop_price;
		const { formErrors, isValid } = formValidator(payload);
		const newData = { quantity, total, price_type };
		term && (newData.term = term?.value);
		price_limit && (newData.price_limit = price_limit);
		stop_price && (newData.stop_price = stop_price);

		isValid ? nextStep(newData) : setFormErrors(formErrors);
	};

	return (
		<form onSubmit={handleSubmit} className="px-4 py-3">
			<CustomInputBox
				name="price"
				label="Price"
				placeholder="Price"
				value={request?.price}
				iconText="NGN"
				disabled
				readonly
			/>

			{price_type === stockTransType.STOP_LIMIT && (
				<CustomInputBox
					name="stop_price"
					type="number"
					label="Stop Price"
					placeholder="Stop Price"
					value={request?.stop_price}
					onChange={handleChange}
					error={formErrors?.stop_price}
					min={0}
					required
				/>
			)}

			{!isMarket && (
				<CustomInputBox
					name="price_limit"
					type="number"
					label="Price Limit"
					placeholder="Price Limit"
					value={request?.price_limit}
					onChange={handleChange}
					error={formErrors?.price_limit}
					min={0}
					required
				/>
			)}

			<CustomInputBox
				name="quantity"
				type="number"
				label="Quantity"
				placeholder="Quantity"
				value={request?.quantity}
				onChange={handleChange}
				error={formErrors?.quantity}
				min={1}
				required
			/>

			<CustomSelect
				name="term"
				placeholder="Order Term"
				label="Order Term"
				value={[request?.term]}
				onChange={(e) => handleSelect("term", e)}
				error={formErrors?.term}
				options={orderTerms}
				getOptionLabel={({ comment }) => comment}
			/>

			<div className="mb-4 pt-4">
				<RangeSelect
					reset={resetRange}
					price={request?.price}
					bal={cashBalance}
					handleClick={handleSelect}
				/>
			</div>

			<CustomInputBox
				name="total"
				placeholder="Total"
				value={total}
				iconText="NGN"
				required
				disabled
			/>

			<div className="flex__between">
				{!order?.portfolioID && (
					<button
						className="btn btn--lg btn--primary--bordered me-3"
						onClick={toggle}
					>
						Cancel
					</button>
				)}

				<button
					type="submit"
					className="btn btn--lg btn--primary ms-3"
					disabled={formErrors?.quantity || request.price === 0}
				>
					Buy
				</button>
			</div>
		</form>
	);
};

export default BuyStockPriceForm;
